var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScalpHairLGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#939393",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 18.7H20.646a6.043 6.043 0 0 1-.449 8.336 6.126 6.126 0 0 1-8.394 0 6.043 6.043 0 0 1-.45-8.336H1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 22.522c0 1.456 1.028 2.699 2.43 2.938 1.403.238 2.769-.597 3.228-1.975.46-1.379-.122-2.895-1.375-3.584.323-3.569 1.617-10.038 6.603-14.839a.322.322 0 0 0 .045-.445.304.304 0 0 0-.435-.046c-6.051 4.289-7.99 11.261-8.609 15.164-1.131.44-1.881 1.548-1.887 2.787z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScalpHairLGray);
export default __webpack_public_path__ + "static/media/icon_scalp_hair_l_gray.e5d151b7.svg";
export { ForwardRef as ReactComponent };